<template>
  <b-modal
    id="wallet-modal"
    ref="wallet-modal"
    centered
    scrollable
    hide-footer
    header-border-variant="white"
    header-class="pb-0"
    body-class="text-center text-black pt-0 rounded-0"
    @hide="closeModal"
  >
    <div class="content">
      <div
        class="w-100 d-flex justify-content-center align-items-center klip-title"
      >
        <img
          src="/img/threespace/company/kakao_klip_logo_color.png"
          width="50"
          v-if="form.isKakaoKlipPc"
          class="float-left klip-icon"
        />
        <img
          src="/img/threespace/logo/space_black.png"
          width="50"
          class="float-left klip-icon"
        />
        <!-- <div class="title">{{ form.title }}</div> -->
        <div class="title">CONNECT to 3space Art</div>
      </div>

      <!-- 지갑 선택 -->
      <template v-if="form.isDefault">
        <p class="mt-2">{{ $t("wallet.connect") }}</p>

        <div>
          <span class="text-danger">{{ form.errorMessage }}</span>
          <b-button
            squared
            block
            class="bg-kakao-klip border-0 mt-2"
            @click="onClickKlip()"
          >
            <img src="/img/threespace/company/kakao_klip_logo_color.png" />
            {{ $t("wallet.connectKlip") }}
          </b-button>
        </div>
      </template>

      <!-- 카카오톡 클립(PC)으로 연결 -->
      <template v-if="form.isKakaoKlipPc">
        <div class="w-100 d-flex justify-content-center">
          <img :src="klip.qrcode" width="160" height="160" class="border-1" />
        </div>
        <div class="w-100 text-center">
          <p>
            <span class="text-gray mr-2">{{
              $t("wallet.modal.remainTime")
            }}</span>
            <span class="text-danger">{{ time }}</span>
          </p>
        </div>
        <div class="w-100 text-center mt-3 mb-5">
          <p>
            {{ $t("wallet.modal.klipQRdescription") }}
          </p>
          <p class="text-gray">
            {{ $t("wallet.modal.klipQRdescription2") }}
          </p>
        </div>
      </template>
      <!-- 카카오톡 클립(모바일)으로 연결 -->
      <template v-if="form.isKakaoKlipMobile">
        <div class="w-100 text-center my-5">
          <p>
            <span class="text-gray mr-2">{{
              $t("wallet.modal.remainTime")
            }}</span>
            <span class="text-danger">{{ time }}</span>
          </p>
        </div>
      </template>

      <template v-if="form.isLogin">
        <div>
          <span class="text-danger">{{ form.errorMessage }}</span>
          <!-- E-mail -->
          <div class="wallet-connect-btn-container">
            <b-button
              squared
              block
              class="border-0 email"
              to="/login"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: #343434 !important;
              "
            >
              <span>{{ $t("wallet.connectThreeSpace") }}</span>
              <img src="/img/threespace/icon/arrow_right.svg" />
            </b-button>
          </div>
          <div class="or_line">
            <div class="text">OR</div>
          </div>
          <!-- <div class="login-border" /> -->
          <!-- SNS -->
          <div class="sns-wrap">
            <button class="sns kakao" @click="onLoginKakao()">
              <img src="/img/threespace/company/kakao-login.svg" />
              <p>Kakao</p>
            </button>
            <button class="sns naver" @click="onLoginNaver()">
              <img src="/img/threespace/company/naver-login.svg" />
              <p>Naver</p>
            </button>
            <button class="sns google" @click="onLoginGoogle()">
              <img src="/img/threespace/company/google-login.svg" />
              <p>Google</p>
            </button>
          </div>

          <div
            class="wallet-connect-btn-container"
            v-if="form.isBtc && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-xverse border-0 mt-2"
              @click="onClickXverse()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/xverse.png" />
              </div>
              <span>{{ $t("wallet.connectXverse") }}</span>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="form.isBtc && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-leather border-0 mt-2"
              @click="onClickLeather()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/leather.png" />
              </div>
              <span>{{ $t("wallet.connectLeather") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container" v-if="form.isKlaytn">
            <b-button
              squared
              block
              class="bg-kakao-klip border-0 mt-2"
              @click="onClickKlip()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/kakao_klip_logo.png" />
              </div>
              <span>{{ $t("wallet.connectKlip") }}</span>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="!isMobile && form.isKlaytn"
          >
            <b-button
              squared
              block
              class="bg-kaikas border-0 mt-2"
              @click="kaikas()"
            >
              <div class="image-container">
                <img
                  src="/img/threespace/company/kaia-wallet.png"
                  height="24"
                />
              </div>
              <span>{{ $t("wallet.connectKaikas") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container" v-if="form.isKlaytn">
            <b-button
              squared
              block
              class="bg-wallet-connect border-0 mt-2"
              @click="onClickNeopin()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/neopin.png" />
              </div>
              <span>{{ $t("wallet.connectNeopin") }}</span>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="(form.isEthereum || form.isPolygon) && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickMetaMask()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/metamask_logo.png" />
              </div>
              <span>{{ $t("wallet.connectMetaMask") }}</span>
              <Metamask ref="metamask" @onComplete="walletLogin"></Metamask>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="(form.isEthereum || form.isPolygon) && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickWepin()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/wepin.png" />
              </div>
              <span>{{ $t("wallet.connectWepin") }}</span>
              <Wepin ref="wepin" @onComplete="wepinLogin"></Wepin>
            </b-button>
          </div>
          <span class="text-danger">{{ form.errorMessage }}</span>
          <div
            class="wallet-connect-btn-container"
            v-if="form.isEthereum || form.isPolygon"
          >
            <b-button
              squared
              block
              class="bg-wallet-connect border-0 mt-2"
              @click="onClickWalletConnect()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/wallet-connect-logo.png" />
              </div>
              <span>{{ $t("wallet.connectWalletConnect") }}</span>
              <WalletConnect
                ref="walletConnect"
                @wallet-info="walletLogin"
              ></WalletConnect>
            </b-button>
          </div>
          <!--
          <div class="modal-separator">
            <hr>
            <p>{{ $t("wallet.modal.separator") }}</p>
            <hr>
          </div>
          <div class="wallet-connect-btn-container">
            <b-button
              squared
              block
              class="bg-three-space border-0 mt-2"
              to="/login"
            >
              <div class="image-container">
                <img
                  src="/img/threespace/company/3space-art.png"
                  width="32"
                />
              </div>
              <span>{{ $t("wallet.connectThreeSpace") }}</span>
            </b-button>
          </div>
          -->
        </div>
      </template>
      <template v-if="form.isNetworkSelect">
        <div>
          <div class="wallet-connect-btn-container" v-if="form.isNeopin">
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickNetwork('Klaytn')"
            >
              <div class="image-container">
                <img
                  src="/img/threespace/company/kaia-wallet.png"
                  height="24"
                />
              </div>
              <span>{{ $t("wallet.connectKlaytn") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container">
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickNetwork('Ethereum')"
            >
              <div class="image-container">
                <img
                  src="/img/threespace/company/ethereum-eth-logo.svg"
                  height="24"
                />
              </div>
              <span>{{ $t("wallet.connectEthereum") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container" v-if="!form.isNeopin">
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickNetwork('Polygon')"
            >
              <div class="image-container">
                <img src="/img/threespace/company/polygon-matic-logo.png" />
              </div>
              <span>{{ $t("wallet.connectPolygon") }}</span>
            </b-button>
          </div>
        </div>
        <Neopin ref="neopin" @wallet-info="walletLogin"></Neopin>
        <Metamask ref="metamask" @onComplete="walletLogin"></Metamask>
        <WalletConnect
          ref="walletConnect"
          @wallet-info="walletLogin"
        ></WalletConnect>
      </template>

      <template v-if="form.isChange">
        <div>
          <span class="text-danger">{{ form.errorMessage }}</span>
          <div
            class="wallet-connect-btn-container"
            v-if="form.isBtc && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-xverse border-0 mt-2"
              @click="onClickXverse()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/xverse.png" />
              </div>
              <span>{{ $t("wallet.connectXverse") }}</span>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="form.isBtc && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-leather border-0 mt-2"
              @click="onClickLeather()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/leather.png" />
              </div>
              <span>{{ $t("wallet.connectLeather") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container" v-if="form.isKlaytn">
            <b-button
              squared
              block
              class="bg-kakao-klip border-0 mt-2"
              @click="onClickKlip()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/kakao_klip_logo.png" />
              </div>
              <span>{{ $t("wallet.connectKlip") }}</span>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="!isMobile && form.isKlaytn"
          >
            <b-button
              squared
              block
              class="bg-kaikas border-0 mt-2"
              @click="kaikas()"
            >
              <div class="image-container">
                <img
                  src="/img/threespace/company/kaia-wallet.png"
                  height="24"
                />
              </div>
              <span>{{ $t("wallet.connectKaikas") }}</span>
            </b-button>
          </div>
          <div class="wallet-connect-btn-container" v-if="form.isKlaytn">
            <b-button
              squared
              block
              class="bg-wallet-connect border-0 mt-2"
              @click="$refs.neopin.onClick()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/neopin.png" />
              </div>
              <span>{{ $t("wallet.connectNeopin") }}</span>
              <Neopin ref="neopin" @wallet-info="walletLogin"></Neopin>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="(form.isEthereum || form.isPolygon) && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickMetaMask()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/metamask_logo.png" />
              </div>
              <span>{{ $t("wallet.connectMetaMask") }}</span>
              <Metamask ref="metamask" @onComplete="emitWalletInfo"></Metamask>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="(form.isEthereum || form.isPolygon) && !isMobile"
          >
            <b-button
              squared
              block
              class="bg-meta-mask border-0 mt-2"
              @click="onClickWepin()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/wepin.png" />
              </div>
              <span>{{ $t("wallet.connectWepin") }}</span>
              <Wepin ref="wepin" @onComplete="wepinLogin"></Wepin>
            </b-button>
          </div>
          <div
            class="wallet-connect-btn-container"
            v-if="form.isEthereum || form.isPolygon"
          >
            <b-button
              squared
              block
              class="bg-wallet-connect border-0 mt-2"
              @click="$refs.walletConnect.reconnect()"
            >
              <div class="image-container">
                <img src="/img/threespace/company/wallet-connect-logo.png" />
              </div>
              <span>{{ $t("wallet.connectWalletConnect") }}</span>
              <WalletConnect
                ref="walletConnect"
                @wallet-info="emitWalletInfo"
              ></WalletConnect>
            </b-button>
          </div>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
import { prepare, request, getResult } from "klip-sdk";
import QRCode from "qrcode";
import WalletConnect from "@/utils/walletConnect";
import Metamask from "@/utils/metamask";
import Wepin from "@/utils/wepin";
import Neopin from "@/utils/neopin";
import { mapActions, createNamespacedHelpers } from "vuex";
import { v4 as uuidv4 } from "uuid";
const authHelper = createNamespacedHelpers("auth");
import * as bitcoin from "bitcoinjs-lib";
import * as btc from "@scure/btc-signer";
import { bytesToHex, hexToBytes } from "@noble/hashes/utils";
import { MarketPlace } from "ordinalsbot";
import { getAddress, signTransaction } from "sats-connect";

export default {
  data: function () {
    return {
      form: this.getInitPage(),
      klip: this.getInitKakaoKlip(),
      isTimeout: false,
      date: this.$moment(60 * 3 * 1000),
      kaikasProvider: window.klaytn,
    };
  },
  mounted() {},
  computed: {
    time: function () {
      return this.date.format("mm : ss");
    },
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
  },
  components: {
    WalletConnect,
    Metamask,
    Neopin,
    Wepin,
  },
  methods: {
    ...mapActions("wallet", ["walletLogin", "wepinLogin"]),
    ...authHelper.mapActions(["findWalletAddr"]),
    onClickKlip() {
      this.klip = this.getInitKakaoKlip();
      const bappName = "3space Art";

      // 타이머
      this.isTimeout = false;
      this.date = this.$moment(60 * 3 * 1000); // 3분
      clearInterval(this.timer);
      clearInterval(this.totalTimer);

      if (this.isMobile) {
        // 인증 요청
        prepare
          .auth({ bappName })
          .then((data) => {
            // 카카오톡 클립 > 정보제공 요청
            this.klip.requestKey = data.request_key;
            request(data.request_key, true);

            this.form = this.getInitPage();
            this.form.isKakaoKlipMobile = true;

            // 결과 조회 전체 타이머
            this.setTotalTimer();
            // 결과 조회
            this.setResultTimer();
          })
          .catch((error) => {
            this.$log.error(error);
            alert(
              "클립(Klip) 인증 오류가 발행하였습니다. 나중에 다시 시도해 주세요."
            );
          });
      } else {
        // 인증 요청
        prepare
          .auth({ bappName })
          .then((data) => {
            // QR 코드 생성
            this.klip.requestKey = data.request_key;
            this.createQRCode(
              "https://klipwallet.com/?target=/a2a?request_key=" +
                this.klip.requestKey
            );
            // 결과 조회 전체 타이머(QR 남은 시간)
            this.setTotalTimer();
            // 결과 조회
            this.setResultTimer();
          })
          .catch((error) => {
            this.$log.error(error);
            alert(
              "클립(Klip) 인증 오류가 발행하였습니다. 나중에 다시 시도해 주세요."
            );
          });
      }
    },
    setTotalTimer() {
      if (!this.isTimeout) {
        this.totalTimer = setInterval(() => {
          this.date = this.date.clone().subtract(1, "seconds");
          if (this.time === "00 : 00") {
            clearInterval(this.timer);
            clearInterval(this.totalTimer);
            this.hide();
          }
        }, 1000);
      }
    },
    setResultTimer() {
      if (!this.isTimeout) {
        this.timer = setInterval(() => {
          let that = this;
          getResult(this.klip.requestKey)
            .then((data) => {
              //this.$log.log(data);
              if (data.status === "completed") {
                const result = {
                  klaytnAddress: data.result.klaytn_address,
                  network: "Klaytn",
                  addr: data.result.klaytn_address,
                  chainId: 8217,
                  walletProvider: "Klip",
                };
                clearInterval(that.timer);
                that.hide();
                that.isTimeout = true;

                // 지갑주소 확인(신규가입인 경우 메시지 표시)
                const walletInfo = {
                  network: "Klaytn",
                  address: data.result.klaytn_address,
                };
                this.findWalletAddr(walletInfo)
                  .then((addrs) => {
                    if (
                      addrs !== undefined &&
                      addrs !== null &&
                      addrs.length > 0
                    ) {
                      that.$emit("wallet-info", result);
                    } else {
                      const confirmMsg = this.$t("login.join.notFound");
                      if (confirm(confirmMsg)) {
                        that.$emit("wallet-info", result);
                      }
                    }
                  })
                  .catch((error) => {
                    this.$log.error(error);
                  });
              }
            })
            .catch((error) => {
              this.$log.error(error);
              clearInterval(that.timer);
            });
        }, 3000);
      }
    },
    createQRCode(_klipURL) {
      QRCode.toDataURL(_klipURL, async (err, url) => {
        this.form = this.getInitPage();
        if (err) {
          this.klip.qrcode = null;
        } else {
          this.form.isKakaoKlipPc = true;
          this.form.title = this.$t("wallet.modal.klipQRTitle");
          this.klip.qrcode = url;
        }
      });
    },
    getInitPage() {
      return {
        title: "CONNECT", //this.$t("wallet.modal.description"),
        isDefault: false,
        isKakaoKlipPc: false,
        isKakaoKlipMobile: false,
        errorMessage: null,
        isLogin: false,
        isChange: false,
        isEthereum: false,
        isPolygon: false,
        isKlaytn: false,
        isBtc: false,
        isNetworkSelect: false,
        isMetamask: false,
        isWalletConnect: false,
        isNeopin: false,
      };
    },
    getInitKakaoKlip() {
      return {
        qrcode: null,
        requestKey: null,
      };
    },
    show() {
      this.form = this.getInitPage();
      this.form.isDefault = true;
      this.$refs["wallet-modal"].show();
    },
    hide() {
      this.$refs["wallet-modal"].hide();
    },
    closeModal() {
      clearInterval(this.timer);
      clearInterval(this.totalTimer);
    },
    login(type = "all") {
      this.form = this.getInitPage();
      this.form.isLogin = true;

      if (type === "all") {
        this.form.isEthereum = true;
        this.form.isPolygon = true;
        this.form.isKlaytn = true;
        this.form.isBtc = true;
      } else {
        this.form[`is${type}`] = true;
      }

      this.$refs["wallet-modal"].show();
    },
    showChangeWallet(type = "all") {
      this.form = this.getInitPage();
      this.form.isChange = true;

      if (type === "all") {
        this.form.isEthereum = true;
        this.form.isPolygon = true;
        this.form.isKlaytn = true;
        this.form.isBtc = true;
      } else {
        this.form[`is${type}`] = true;
      }
      this.$refs["wallet-modal"].show();
    },
    emitWalletInfo(data) {
      this.hide();
      this.$emit("wallet-info", data);
    },
    async kaikas() {
      if (this.kaikasProvider !== undefined) {
        const klaytn = this.kaikasProvider;

        try {
          const accounts = await klaytn.enable();

          klaytn.on("accountsChanged", function (accounts) {
            console.log("Accounts changed", klaytn.selectedAddress);
          });
          klaytn.on("networkChanged", function () {
            console.log("Network changed", klaytn.networkVersion);
          });

          if (process.env.NODE_ENV === "production") {
            if (klaytn.networkVersion.toString() !== "8217") {
              alert("Please select the Klaytn Mainnet");
              return;
            }
          }

          if (process.env.NODE_ENV !== "production") {
            console.log(klaytn.networkVersion);
            if (klaytn.networkVersion.toString() !== "1001") {
              alert("We highly recommend using baobab network in Test server");
            }
          }

          const result = {
            klaytnAddress: accounts[0],
            network: "Klaytn",
            addr: accounts[0],
            chainId: klaytn.networkVersion,
            walletProvider: "Kaikas",
          };

          this.hide();
          this.$emit("wallet-info", result);
        } catch (error) {
          console.error(error);
        }
      } else {
        window.location.href =
          "https://chrome.google.com/webstore/detail/kaikas/jblndlipeogpafnldhgmapagcccfchpi";
      }
    },
    onLoginKakao() {
      const redirect_uri =
        process.env.VUE_APP_BACKEND_API_URL +
        "/threespace/v1/join/kakao/callback";
      const url = `https://kauth.kakao.com/oauth/authorize?client_id=80e3176f5940dbb2f27f3b44d5fd124d&redirect_uri=${redirect_uri}&response_type=code`;

      window.location.href = url;
    },
    onLoginNaver() {
      const redirect_uri =
        process.env.VUE_APP_BACKEND_API_URL +
        "/threespace/v1/join/naver/callback?referral=";
      const state = uuidv4();
      const url = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=9kK4tH7jbFwIgYMBleCG&redirect_uri=${redirect_uri}&state=${state}`;

      window.location.href = url;
    },
    onLoginGoogle() {
      const redirect_uri =
        process.env.VUE_APP_BACKEND_API_URL +
        "/threespace/v1/join/google/callback";
      const url =
        `https://accounts.google.com/o/oauth2/v2/auth?client_id=713701466995-jef2uanlhjor7gbe5e15c20fodnar88u.apps.googleusercontent.com&redirect_uri=${redirect_uri}&response_type=code` +
        `&scope=openid%20email%20profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuser.phonenumbers.read&access_type=offline`;

      window.location.href = url;
    },
    async broadcast(hex) {
      const response = await fetch("https://blockstream.info/api/tx", {
        method: "POST",
        body: hex,
      });

      return response.json();
    },
    async createListing(address) {
      const psbt =
        "cHNidP8BAFICAAAAAVY1lBXCYZVvhcSXFz2EJdNuVh6u75ofEcUhNQ4Nj03qAAAAAAD/////AQD6AAAAAAAAFgAUOXSa9cx6l7zdzvB1IekPqJEjnDcAAAAAAAEA/TQDAQAAAAABAQRY+TUCHQgn17FJYEUOlOLYc7RAKQYEluPp0PKXRUrIAAAAAAD9////ARAnAAAAAAAAIlEgtgRNoZ4CAwLOAthJ4nz2IZbY8Vs+RTpnJH/OujIpO0YDQFtmhwsKL6354Wl9yTIG7Nvd+xVOTEA2FAktUbK6hX+n+qqmuq91/kYpGKRoJ462kZGdGdZQahTtfZ8Evyj3atb9bQIgw4+qP/fnwVIR8HPhc2zVie9pDQj+0cDpdPLGKKr1HPqsAGMDb3JkAQEJaW1hZ2UvcG5nAQUbomRuYW1lZjNzcGFjZWZhcnRpc3RmM3NwYWNlAE0IAolQTkcNChoKAAAADUlIRFIAAAARAAAAEQgGAAAAO21H+gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAFzUkdCAK7OHOkAAAAEZ0FNQQAAsY8L/GEFAAABqklEQVR4AZ2TzU7CQBCAZ7pEkIgpiokQE3uEk/gE4hPoG8DRm3LySH0C4xOIT6CPwNEbvRg5loPKgegaSSgoHWdLJW2tAZxkd/Zn9tudn0WISG6nWHFdqBKBoeYIZLmEV7LXseEPwZ+Bvl00EOmWl8qAKIHI8rcqniFC011x6tK2ZRSSmAE0bAOB5BccypfHVhDOqsatgaNkmfV+FCJUt5rJtVk5HqDXsYIGzqAvubVSa7kuIp6k13M4/Oi3QpTNQuk4my8S31iDObJRKDaz+dKbbhh6cF0joCP2WPILmvMgHHC2IT3hpMphiJcFsmAxsVVHYpq5GQSQONqoL4QQk1g7DUnrsjaifsYyQHhuTECEXq65RHfKT22cOpsH4Zg0WNny6SEEEZw+O53ZyhLAOev34aB/HwfgzFyzqnAM63wmBPGKzU0mTRyPDojoko33NA1uvhLTIIpP4G9Ap3zYc4X3dqMXYHDCtWJyeVd5aITNyCLCunoJ7ze4ma/PnYtYSABWET5oIoQVjIF/0S/Q0qJAqsrZdRXo6d9ZVvy/pLwwVTL+BQmCCNH5Bjr2qtpijdUNWgAAAABJRU5ErkJggmghwcOPqj/358FSEfBz4XNs1YnvaQ0I/tHA6XTyxiiq9Rz6AAAAAAEBKxAnAAAAAAAAIlEgtgRNoZ4CAwLOAthJ4nz2IZbY8Vs+RTpnJH/OujIpO0YBAwSDAAAAARcgOca3g3xZddXEAfdBBCGwHESXd5l0V0MAXJ5xNs+iT4wAAA==";

      const params = {
        hex: bitcoin.Psbt.fromBase64(psbt, {
          network: bitcoin.networks.testnet,
        }).toHex(),
        allowedSighash: [
          bitcoin.Transaction.SIGHASH_SINGLE,
          bitcoin.Transaction.SIGHASH_ANYONECANPAY,
        ],
        signAtIndex: [0],
        network: "testnet",
      };

      const result = await window.btc.request("signPsbt", params);

      return result.result.hex;
    },
    getBase64FromHex(hex) {
      return bitcoin.Psbt.fromHex(hex).toBase64();
    },
    async onClickXverse() {
      const network =
        process.env.NODE_ENV === "production" ? "Mainnet" : "Testnet";

      const getAddressOptions = {
        payload: {
          purposes: ["ordinals", "payment"],
          message: "Address for receiving Ordinals and payments",
          network: {
            type: network,
          },
        },
        onFinish: (response) => {
          console.log(response);

          const paymentAddress = response.addresses.find(
            (address) => address.purpose === "payment"
          );
          const ordinalsAddress = response.addresses.find(
            (address) => address.purpose === "ordinals"
          );

          const result = {
            btcAddress: paymentAddress.address,
            addrType: "P2SH",
            network: "Btc",
            addr: paymentAddress.address,
            chainId: "",
            walletProvider: "Xverse",
            ordinalsAddr: ordinalsAddress.address,
            ordinalsPublicKey: ordinalsAddress.publicKey,
            publicKey: paymentAddress.publicKey,
          };

          this.hide();
          this.$emit("wallet-info", result);
        },
        onCancel: () => alert("Request canceled"),
      };

      try {
        await getAddress(getAddressOptions);
      } catch (error) {
        if (confirm(this.$t("wallet.validation.notFoundXverse"))) {
          window.open(
            "https://chromewebstore.google.com/detail/xverse-wallet/idnnbdplmphpflfnlkomgpfbpcgelopg",
            "_blank"
          );
        }
        this.hide();
      }
    },
    async onClickLeather() {
      // check leather wallet
      if (window.LeatherProvider) {
        const walletInfo = await window.btc.request("getAddresses");

        const paymentAddress = walletInfo.result.addresses.find(
          (address) => address.type === "p2wpkh"
        );
        const ordinalsAddress = walletInfo.result.addresses.find(
          (address) => address.type === "p2tr"
        );

        const result = {
          btcAddress: paymentAddress.address,
          addrType: paymentAddress.type,
          network: "Btc",
          addr: paymentAddress.address,
          chainId: "",
          walletProvider: "Leather",
          ordinalsAddr: ordinalsAddress.address,
        };

        this.hide();
        this.$emit("wallet-info", result);

        // const hex = await this.createListing(tapRootAddress.address)
        //
        // console.log(this.getBase64FromHex(hex))

        // const API_KEY = "e53944f0-8c0a-4d9d-9870-232822b166e2"
        //
        // let marketplace = new MarketPlace(API_KEY, "dev");
        //
        // const id = "ea4d8f0d0e3521c5111f9aefae1e566ed325843d1797c4856f9561c215943556i0"
        // const paymentAddress = "2N9onarCjH76wYengmh72B5Gci8oTm7r7kL";
        // const ordinalsAddress = "tb1p3l7j48ss4l5uzh3nflu54s5a5x0fenw58m3e53dqf75zjxtp5suqa5n46d";
        // const paymentPublicKey = "0225decb5d83a3259716c6c9979e68a1e7b58128db5ebc65b21910c96c0475ddc1"
        //
        // let addresses = "";
        // const getAddressOptions = {
        //   payload: {
        //     purposes: ['ordinals', 'payment'],
        //     message: 'Address for receiving Ordinals and payments',
        //     network: {
        //       type:'Testnet'
        //     },
        //   },
        //   onFinish: (response) => {
        //     console.log(response.addresses)
        //     addresses = response.addresses
        //   },
        //   onCancel: () => alert('Request canceled'),
        // }
        //
        // await getAddress(getAddressOptions);
        //
        // console.log(addresses[1].address)
        // console.log(addresses[1].publicKey)

        // const setPadding = await marketplace.setupPaddingOutputs({
        //   address:addresses[1].address,
        //   publicKey:addresses[1].publicKey,
        //   walletProvider:"Xverse",
        // })

        // const createRequest = {
        //   ordinalId: id,
        //   buyerPaymentAddress: addresses[1].address,
        //   buyerOrdinalAddress: addresses[0].address,
        //   buyerPaymentPublicKey: addresses[1].publicKey,
        // }
        //
        // const response = await marketplace.createOffer(createRequest)
        //
        //
        // const buyerInput = {
        //   address: addresses[1].address,
        //   signingIndexes: response.buyerInputIndices,
        // }
        //
        // const pss = bitcoin.Psbt.fromBase64(response.psbt, {network:bitcoin.networks.testnet});
        //
        // console.log(pss.txInputs);
        // console.log(pss.txOutputs)
        //
        // const payload = {
        //   network: { type: "Testnet" },
        //   message: "Sign Buyer Transaction",
        //   psbtBase64: response.psbt,
        //   broadcast: false,
        //   inputsToSign: [buyerInput],
        // };
        //
        // let psbt64 = '';
        //
        // await signTransaction({
        //   payload,
        //   onFinish: async(response) => {
        //     try {
        //       console.log(response)
        //
        //       psbt64 = response.psbtBase64
        //       const result = await marketplace.submitOffer({
        //         ordinalId:id,
        //         signedBuyerPSBTBase64: psbt64
        //       })
        //
        //       console.log(result);
        //       console.log('bye');
        //
        //       // Here make a call to /submit-offer
        //       // Things to do after successful signing
        //     } catch (Error) {
        //       // error handling
        //     }
        //   },
        //   onCancel: () => { // User cancelled signing request }
        //   }
        // });
        //
        // console.log(psbt64);

        // console.log('hi??')
        // const tx = btc.Transaction.fromPSBT(hexToBytes(bitcoin.Psbt.fromBase64(psbt64).toHex()))
        // console.log(tx.hex);
        // const result = await this.broadcast(tx.hex)
        // console.log(result)

        // const buyPsbt = "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"

        // const psbtBuying = bitcoin.Psbt.fromBase64(buyPsbt, {network: bitcoin.networks.testnet})
        //
        //
        // console.log(psbtBuying.data)
        // const params = {
        //   hex: psbtBuying.toHex(),
        //   allowedSighash: [bitcoin.Transaction.SIGHASH_DEFAULT],
        //   network: "testnet",
        //   signAtIndex: [0,1,3]
        // }
        //
        //
        // console.log(psbtBuying.txOutputs)
        // console.log(psbtBuying.txInputs)
        //
        // const buyResult = await window.btc.request('signPsbt', params)
        //
        // console.log(buyResult);

        // const tx = btc.Transaction.fromPSBT(hexToBytes(newResult.result.hex))
        // tx.finalize();
        // await broadcast(tx.hex);

        //
        // console.log(newPsbt.result.hex);
        //
        // const tx = btc.Transaction.fromPSBT(hexToBytes(newPsbt.result.hex))
        // tx.finalize()
        //
        // console.log(tx)

        // const resultNew = "70736274ff0100af0200000001213fd934d1aed0fa5f2363213f1cd42edf0987f953f6ef1125bc117519f2ae100000000000ffffffff04580200000000000016001466547512d5cf712db59ad5177e932d1571f4c24a580200000000000016001466547512d5cf712db59ad5177e932d1571f4c24a580200000000000016001466547512d5cf712db59ad5177e932d1571f4c24a16611d000000000016001466547512d5cf712db59ad5177e932d1571f4c24a00000000000100de02000000000101283b8b9702fb91835e544e06b0ae5feafaf040b5347a65880147d1cb4d9cb78e0100000000fdffffff0264691d000000000016001466547512d5cf712db59ad5177e932d1571f4c24a1d761ee500000000160014c10331ed88cb353a1b4871a8fd5030ddf14a86720247304402206d76b73062f5f3972af071f1b89e967cd89ec4468ae01755191b81622e4de92102205e5666e9e27841ac91c1c621297c4cf1093265998f3329c0d34abb63b075a1f201210317288bb64b9c119763801e25f70c534a7a902c7d8c3b5060e65a337a12ffb63c023d27002202029248d0affe45fc20cd373f415b7b06804a11ed954d7321aeaaa1ba2f931202f247304402201b96743c1ed8d2c3e59ff2c526b8de9c786062fa2ea10d38bde416894109248a02205042b81047d0de7d111004a2ba6c6189189eae833e72ef67085a019a157ecf84010000000000"

        // const params = {
        //   hex: newPsbt.toHex(),
        //   network: "testnet"
        // }
        // const newSignPsbt = await window.btc.request('signPsbt', params);
        //
        // console.log(newSignPsbt);

        // const psbt = "cHNidP8BAFICAAAAAZ7yHkB5S5HUTHa0WLLrgTgbIsZD8xkjpFwuH24wwsrJAAAAAAD/////AYiQAAAAAAAAFgAUOXSa9cx6l7zdzvB1IekPqJEjnDcAAAAAAAEA/RYDAQAAAAABAa2AC3t1/0C6GyuW01xXDWm5aHbRPjZFIAQOQwKsZwvkAAAAAAD9////ARAnAAAAAAAAIlEgtgRNoZ4CAwLOAthJ4nz2IZbY8Vs+RTpnJH/OujIpO0YDQBF+g3db2Nj6ux7e8pwxhokZKsvbVUQxSG1ol5CdhhK63pcpCEbflh2eJEHiMaBK3Ty/8i+dj60+lB0Bqbl2Ttn9TwIgfzPswpPjYnQIXMIg6WeA7jus47RYnFhPA4WeHMoDBemsAGMDb3JkAQEJaW1hZ2UvcG5nAE0IAolQTkcNChoKAAAADUlIRFIAAAARAAAAEQgGAAAAO21H+gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAFzUkdCAK7OHOkAAAAEZ0FNQQAAsY8L/GEFAAABqklEQVR4AZ2TzU7CQBCAZ7pEkIgpiokQE3uEk/gE4hPoG8DRm3LySH0C4xOIT6CPwNEbvRg5loPKgegaSSgoHWdLJW2tAZxkd/Zn9tudn0WISG6nWHFdqBKBoeYIZLmEV7LXseEPwZ+Bvl00EOmWl8qAKIHI8rcqniFC011x6tK2ZRSSmAE0bAOB5BccypfHVhDOqsatgaNkmfV+FCJUt5rJtVk5HqDXsYIGzqAvubVSa7kuIp6k13M4/Oi3QpTNQuk4my8S31iDObJRKDaz+dKbbhh6cF0joCP2WPILmvMgHHC2IT3hpMphiJcFsmAxsVVHYpq5GQSQONqoL4QQk1g7DUnrsjaifsYyQHhuTECEXq65RHfKT22cOpsH4Zg0WNny6SEEEZw+O53ZyhLAOev34aB/HwfgzFyzqnAM63wmBPGKzU0mTRyPDojoko33NA1uvhLTIIpP4G9Ap3zYc4X3dqMXYHDCtWJyeVd5aITNyCLCunoJ7ze4ma/PnYtYSABWET5oIoQVjIF/0S/Q0qJAqsrZdRXo6d9ZVvy/pLwwVTL+BQmCCNH5Bjr2qtpijdUNWgAAAABJRU5ErkJggmghwH8z7MKT42J0CFzCIOlngO47rOO0WJxYTwOFnhzKAwXpAAAAAAEBKxAnAAAAAAAAIlEgtgRNoZ4CAwLOAthJ4nz2IZbY8Vs+RTpnJH/OujIpO0YBAwSDAAAAARcgOca3g3xZddXEAfdBBCGwHESXd5l0V0MAXJ5xNs+iT4wAAA=="
        //
        //
        // const psbting = bitcoin.Psbt.fromBase64(psbt);
        //
        //
        // const params = {
        //   hex: psbting.toHex(),
        //   network: "testnet"
        // }
        // const requestParams = {...params}
        //
        // const sign = await window.btc.request('signPsbt', requestParams);
        //
        // console.log(sign.result.hex)
        //
        // const resultBase64 = bitcoin.Psbt.fromHex(sign.result.hex).toBase64();
        //
        // console.log(resultBase64)

        // console.log(bitcoin.Transaction.SIGHASH_SINGLE | bitcoin.Transaction.SIGHASH_ANYONECANPAY)
      } else {
        window.open(
          "https://chromewebstore.google.com/detail/leather/ldinpeekobnhjjdofggfgjlcehhmanlj",
          "_blank"
        );
      }
    },
    onClickMetaMask() {
      // all
      if (this.form.isEthereum && this.form.isPolygon) {
        this.form = this.getInitPage();
        this.form.isNetworkSelect = true;
        this.form.isMetamask = true;
      }
      // showChangeWallet Ethereum
      if (this.form.isEthereum && !this.form.isPolygon) {
        this.$refs.metamask.onClick("ethereum");
      }
      // showChangeWallet Ethereum
      if (!this.form.isEthereum && this.form.isPolygon) {
        this.$refs.metamask.onClick("polygon");
      }
    },
    onClickWalletConnect() {
      // all
      if (this.form.isEthereum && this.form.isPolygon) {
        this.form = this.getInitPage();
        this.form.isNetworkSelect = true;
        this.form.isWalletConnect = true;
      }
      // showChangeWallet Ethereum
      if (this.form.isEthereum && !this.form.isPolygon) {
        this.$refs.walletConnect.onClick("ETHEREUM");
      }
      // showChangeWallet Ethereum
      if (!this.form.isEthereum && this.form.isPolygon) {
        this.$refs.walletConnect.onClick("POLYGON");
      }
    },
    onClickNeopin() {
      // all
      if (this.form.isEthereum && this.form.isKlaytn) {
        this.form = this.getInitPage();
        this.form.isNetworkSelect = true;
        this.form.isNeopin = true;
      }
      // showChangeWallet Ethereum
      if (this.form.isEthereum && !this.form.isKlaytn) {
        this.$refs.neopin.onClick("Ethereum");
      }
      // showChangeWallet Ethereum
      if (!this.form.isEthereum && this.form.isKlaytn) {
        this.$refs.neopin.onClick("Klaytn");
      }
    },
    onClickWepin() {
      this.$refs.wepin.onClick();
    },
    onClickNetwork(network) {
      if (this.form.isWalletConnect) {
        this.$refs.walletConnect.onClick(network);
      } else if (this.form.isNeopin) {
        this.$refs.neopin.onClick(network);
      } else {
        this.$refs.metamask.onClick(network);
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.totalTimer);
  },
};
</script>
